
import {
  Component,
  Vue
} from 'vue-property-decorator'
import {
  ToastModule
} from '@/store/modules/ToastModule'
import EmployeeModalService from '../services/employee-modal-service'
import Countries from '@/data/countries.json'
import Currencies from '@/data/currency.json'
import {
  mask
} from 'vue-the-mask'
import {
  AuthModule
} from '@/store/modules/AuthModule'
import {
  Validations
} from 'vuelidate-property-decorators'
import {
  Vuelidate
} from 'vuelidate'
import {
  NotifyModule
} from '@/store/modules/NotifyModule'
import {
  email,
  alphaNum,
  numeric,
  required,
  minLength
} from 'vuelidate/lib/validators'

  @Component({
    name: 'EmployeeModal',
    directives: {
      mask
    }
  })
export default class EmployeeModal extends Vue {
    protected genderTypes = ['Male', 'Female']
    protected types = ['casual', 'owner', 'Full-Time', 'Part-Time', 'temporary', 'volunteer']
    protected categories = ['driver', 'labour', 'staff']
    protected countries = Countries
    protected isEditForm = false
    protected nationalities = ['Sinhala', 'Tamil', 'Muslim', 'Burgher', 'Malay']
    protected addresses: any = []
    protected currencies = Currencies
    protected addressTypes = ['Secondary', 'Temporary', 'Other']
    protected addressType: any = null
    protected invoiceTerms: any = []

    protected employee: any = {
      id: null,
      type: null,
      category: null,
      name: null,
      email: null,
      designation: null,
      nic_number: null,
      sex: null,
      nationality: null,
      date_of_birth: null,
      mobile_number: null,
      home_number: null,
      is_list: false,
      is_active: false,
      created_user: null,
      modified_user: null
    }

    protected primaryAddress: any = {
      id: null,
      type: null,
      address: null,
      postal_code: null,
      country: null
    }

    protected address: any = {
      id: null,
      type: null,
      address: null,
      postal_code: null,
      country: null
    }

    $v: Vuelidate

    @Validations()
    validations = {
      employee: {
        name: {
          required,
          minLength: minLength(5)
        },
        nic_number: {
          alphaNum,
          minLength: minLength(7)
        },
        designation: {
          minLength: minLength(5)
        },
        email: {
          email
        },
        mobile_number: {
          numeric,
          minLength: minLength(10)
        },
        home_number: {
          numeric,
          minLength: minLength(10)
        }
      }
    }

    public open () {
      (this.$refs.EmployeeModal as any).show()
    }

    public close () {
      this.isEditForm = false
      this.cancel();
      (this.$refs.EmployeeModal as any).hide()
    }

    public cancel () {
      this.reset(this.employee)
      this.reset(this.primaryAddress)
      this.reset(this.address)
      this.addressType = null
      this.$nextTick(() => {
        this.$v.employee.$reset()
      })
    }

    protected isNumber ($event: any) {
      const charCode = ($event.keyCode ? $event.keyCode : $event.which)
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        $event.preventDefault()
      } else {
        return true
      }
    }

    public populateEmployee (id = 0) {
      if (id === 0) return false
      EmployeeModalService.getEmployee(id).then((response) => {
        this.isEditForm = true
        this.employee = response.data
        this.employee.is_active = response.data.is_active === 1
        if (response.data.primary_address !== null) {
          this.primaryAddress = {
            id: response.data.primary_address.id,
            address: response.data.primary_address.address,
            postal_code: response.data.primary_address.postal_code,
            country: response.data.primary_address.country
          }
        }
      })
    }

    protected setAddress (type) {
      this.reset(this.address)
      EmployeeModalService.getAddress(this.employee.id, type).then((response) => {
        if (response.data !== 'empty') {
          this.address = response.data
        }
      })
    }

    protected save () {
      this.$v.$touch()
      if (this.$v.$invalid) return NotifyModule.set('There are fields that require your attention')

      this.primaryAddress.type = 'Primary'
      this.address.type = this.addressType
      this.primaryAddress.source_type = this.address.source_type = 'Employee'
      this.primaryAddress.source_id = this.address.source_id = this.employee.id
      this.employee.created_user = this.primaryAddress.created_user = this.address.created_user = AuthModule.user.fullname
      this.employee.modified_user = this.primaryAddress.modified_user = this.address.modified_user = AuthModule.user.fullname

      const employee: any = {}
      employee.basic = this.employee
      employee.primary_address = this.primaryAddress.address !== null || this.primaryAddress.postal_code !== null || this.primaryAddress.country !== null ? this.primaryAddress : null
      employee.address = this.address.type !== null && (this.address.address !== null || this.address.postal_code !== null || this.address.country !== null) ? this.address : null
      // employee.add_to_list = this.addToList

      delete employee.basic.primary_address

      if (this.isEditForm) this.update(employee)
      else this.create(employee)
    }

    protected create (employee: any) {
      EmployeeModalService.create(employee).then((response) => {
        ToastModule.message(response.data.message)
        this.close();
        (this.$parent as any).populateEmployees()
        this.$emit('employees-updated')
      }).catch(error => {
        console.log(error)
      })
    }

    protected update (employee: any) {
      EmployeeModalService.update(employee).then((response) => {
        ToastModule.message(response.data.message)
        this.close();
        (this.$parent as any).populateEmployees()
        this.$emit('employees-updated')
      }).catch(error => {
        console.log(error)
      })
    }

    protected reset (obj: any) {
      for (const key in obj) {
        obj[key] = null
      }
    }
}

